import {
  ActionTakenEnum,
  DetectingModules,
  DetectingTechnologies,
  ThreatType,
} from '@nirvana/shared/dtos/types/shared/threats';
import { CommonThreatsNavigationHelper } from './common.threats.navigation.helper';
import { Column, Filter } from '@nirvana/shared/dtos/types/shared/filters';
import { WebsitesBlockedNavigationFiltersParams } from '../navigation.interfaces';

export class WebsitesBlockedNavigationHelper {
  public static getDisplayedColumns(shouldDisplayThreatTypeColumn: boolean): Array<Column> {
    const columns = [Column.LAST_DETECTED, Column.DETECTING_MODULE, Column.DETECTING_TECHNOLOGY, Column.ACTION_TAKEN];

    if (shouldDisplayThreatTypeColumn) {
      // push instead of slice because columns are sorted in frontend
      columns.push(Column.THREAT_TYPE);
    }

    return columns;
  }

  public static getFiltersForNavigationItem(params: WebsitesBlockedNavigationFiltersParams): Array<Filter> {
    const filters = [
      CommonThreatsNavigationHelper.getLastDetectedOnFilterFromTimeRange(params.timeRange),
      CommonThreatsNavigationHelper.getCategoryFilter(),
      WebsitesBlockedNavigationHelper.getActionsTakenFilter(),
      CommonThreatsNavigationHelper.getDeviceNameFilter(),
      WebsitesBlockedNavigationHelper.getDetectingModuleFilter(),
      WebsitesBlockedNavigationHelper.getDetectingTechnologyFilter(params.itemKey),
    ];

    if (params.threatTypes.length) {
      // splice instead of push because filters need to have a specific order
      filters.splice(4, 0, CommonThreatsNavigationHelper.getThreatTypeFilter(params.threatTypes));
    }

    return !params.isPartner ? filters : filters.concat(CommonThreatsNavigationHelper.getCompanyFilter(params.targets));
  }

  private static getActionsTakenFilter(): Filter {
    return {
      actionTaken: {
        in: [ActionTakenEnum.BLOCKED],
      },
    };
  }

  private static getDetectingTechnologyFilter(itemKey: string): Filter {
    let detectingTechonology: Array<DetectingTechnologies> = [];
    switch (itemKey) {
      case 'malware':
        detectingTechonology = [
          DetectingTechnologies.NETWORK_PROTECTION_WEB_PROTECTION_WEB_TRAFFIC_SCAN,
          DetectingTechnologies.NETWORK_PROTECTION_WEB_PROTECTION_HYPER_DETECT,
        ];
        break;
      case 'phishing':
      case 'fraud':
        detectingTechonology = [DetectingTechnologies.NETWORK_PROTECTION_WEB_PROTECTION_ANTIPHISING];
        break;
      case 'title':
        detectingTechonology = [
          DetectingTechnologies.NETWORK_PROTECTION_WEB_PROTECTION_WEB_TRAFFIC_SCAN,
          DetectingTechnologies.NETWORK_PROTECTION_WEB_PROTECTION_ANTIPHISING,
          DetectingTechnologies.NETWORK_PROTECTION_WEB_PROTECTION_HYPER_DETECT,
        ];
        break;
      default:
        throw new Error(`Unknown category ${itemKey}.`);
    }

    return {
      detectingTechnology: {
        in: detectingTechonology,
      },
    };
  }

  private static getDetectingModuleFilter(): Filter {
    return {
      detectingModule: {
        in: [DetectingModules.NETWORK_PROTECTION],
      },
    };
  }
}
